import { rejects } from "assert";
import { useNavigate } from "react-router-dom";
import PlacementApi from "./services/placement";
import UserApi from "./services/user";
import StudentSlice from "./StudentSlice";


export const StudentActions = StudentSlice.actions

export const getUserDetailsAction = () => {
    return async (dispatch:any) => {
        const response = await UserApi.getUserDetailsService();
        dispatch(StudentActions.setStudentDetails(response))
    }

}
export const getProgress = () => {
    return async (dispatch:any) => {
        const response = await PlacementApi.getProgressService();
        dispatch(StudentActions.setProgessDetails(response))
    }

}
export const GetRequests = () => {
    return async (dispatch:any) => {
        const response = await PlacementApi.getRequests();
        dispatch(StudentActions.setRequests(response))
    }
}
export const getTasks = () => {
    return async (dispatch:any) => {
        const response = await PlacementApi.getTaskDetails();
        dispatch(StudentActions.setTasks(response))
    }
}
export const getPlacementDetails = () => {
    return async (dispatch:any) => {
        const response = await PlacementApi.getPlacementDetails();
        dispatch(StudentActions.setPlacementDetail(response))
    }

}
export const getEvents = (type:string) => {
    return async (dispatch:any) => {
        const response = await PlacementApi.getEventsList(type)
        dispatch(StudentActions.setEvents(response))
    }
}
export const getAttendanceDetails = () => {
    return async (dispatch:any) => {
        const response = await PlacementApi.getAttendanceDetails();
        dispatch(StudentActions.setAttendanceDetails(response))
    }

}
export const getNotifications = () => {
    return async (dispatch:any) => {
        const response = await UserApi.getNotifications();
        dispatch(StudentActions.setNotifications(response))
    }

}